import React, { useState } from 'react';
import { PlusIcon, MinusIcon } from 'lucide-react';
import { SectionHeading } from './ui/SectionHeading';
import { faqs } from '../data/faqs';
export function Faq() {
  const [open, setOpen] = useState<number | null>(0);
  return <section className="w-full bg-cream px-5 py-16 sm:px-8 lg:py-24" data-id="element-30" data-mp="1lc1yd7n3qtoj">
      <div className="mx-auto max-w-2xl" data-id="element-31" data-mp="1gdqpaz4msn7d">
        <SectionHeading overline="FAQ" title={<>
              Frequently asked{' '}
              <span className="italic text-terracotta-500" data-id="element-33" data-mp="291mku0igs92k">questions</span>
            </>} data-id="element-32" data-mp="1gauqz9ovfwie" />

        <ul className="mt-10 divide-y divide-gold-200/70 border-y border-gold-200/70" data-id="element-34" data-mp="241qpepnu1pym">
          {faqs.map((faq, index) => {
          const isOpen = open === index;
          const Icon = isOpen ? MinusIcon : PlusIcon;
          return <li key={faq.question} data-id="element-35" data-mp="soeksck913be" data-mpi={index}>
                <h3 data-id="element-36" data-mp="no9z884hhieb">
                  <button type="button" onClick={() => setOpen(isOpen ? null : index)} aria-expanded={isOpen} aria-controls={`faq-panel-${index}`} className="flex w-full items-center justify-between gap-6 py-5 text-left transition-colors duration-200 ease-soft hover:text-sage-600 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-gold-500" data-id="element-37" data-mp="nnqrfk8jsae0">
                    <span className="font-serif text-[1.15rem] leading-snug text-sage-800" data-id="element-38" data-mp="6qexjaytqjqt">
                      {faq.question}
                    </span>
                    <Icon className="h-4 w-4 flex-none text-gold-600" aria-hidden="true" data-id="element-39" data-mp="3syoeqjyl3h5m" />
                  </button>
                </h3>
                <div id={`faq-panel-${index}`} hidden={!isOpen} className="pb-6 pr-8 text-[14.5px] leading-relaxed text-ink-soft" data-id="element-40" data-mp="3jxymtrcg2ax6">
                  {faq.answer}
                </div>
              </li>;
        })}
        </ul>
      </div>
    </section>;
}